export function dataURLtoFile(dataurl, filename) {
  let arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  // ไม่ส่ง filename มา File จะตั้งชื่อว่า "undefined" แล้วไปโผล่เป็น key บน S3
  const name = filename || `customization.${(mime.split("/")[1] || "png").toLowerCase()}`;

  return new File([u8arr], name, { type: mime });
}
